"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
const styles_1 = require("@material-ui/core/styles");
const Theme_1 = __importDefault(require("../../Theme"));
const UserMenu_1 = __importDefault(require("../UserMenu"));
const HeaderBar = (props) => {
    var _a;
    const useStyles = styles_1.makeStyles((theme) => styles_1.createStyles({
        appBar: {
            [theme.breakpoints.up("md")]: {
                width: `calc(100% - ${props.sidemenuWidth}px)`,
                marginLeft: props.sidemenuWidth,
            },
        },
        menuButton: {
            display: "none",
        },
        title: {
            flexGrow: 1,
        },
        headerbarIcon: {
            marginRight: "1rem",
        },
    }));
    const classes = useStyles(Theme_1.default);
    const getIcon = (Icon) => {
        var _a, _b, _c, _d;
        return props.titleIconTooltipText ? (react_1.default.createElement(core_1.Tooltip, { title: props.titleIconTooltipText, arrow: true },
            react_1.default.createElement(Icon, { classes: {
                    root: `headerbar-icon ${(_a = props.title) === null || _a === void 0 ? void 0 : _a.toLowerCase()}-headerbar-icon`,
                }, className: classes.headerbarIcon, "data-testid": `${(_b = props.title) === null || _b === void 0 ? void 0 : _b.toLowerCase()}-headerbar-icon`, onClick: props.handleTitleIconClick, style: props.handleTitleIconClick ? { cursor: "pointer" } : {} }))) : (react_1.default.createElement(Icon, { classes: { root: `headerbar-icon ${(_c = props.title) === null || _c === void 0 ? void 0 : _c.toLowerCase()}-headerbar-icon` }, className: classes.headerbarIcon, "data-testid": `${(_d = props.title) === null || _d === void 0 ? void 0 : _d.toLowerCase()}-headerbar-icon`, onClick: props.handleTitleIconClick }));
    };
    const renderUserMenu = () => (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.Hidden, { xsDown: true, implementation: "css" },
            react_1.default.createElement(UserMenu_1.default, { onSignOut: props.onSignOut, title: props.userMenuTitle })),
        react_1.default.createElement(core_1.Hidden, { smUp: true, implementation: "css" },
            react_1.default.createElement(UserMenu_1.default, { onSignOut: props.onSignOut }))));
    const renderLogo = () => {
        const logo = props[props.koneStyle ? "defaultLogo" : "secondaryLogo"];
        return logo ? react_1.default.createElement("img", { src: logo, alt: "logo" }) : null;
    };
    return (react_1.default.createElement(core_1.AppBar, { color: props.koneStyle ? "primary" : "secondary", position: "fixed", className: classes.appBar },
        react_1.default.createElement(core_1.Toolbar, null,
            react_1.default.createElement(core_1.IconButton, { color: "inherit", "aria-label": "open drawer", edge: "start", onClick: props.handleSidebarToggle, className: classes.menuButton },
                react_1.default.createElement(icons_1.Menu, null)),
            props.titleIcon && getIcon(props.titleIcon),
            react_1.default.createElement(core_1.Typography, { variant: "h6", noWrap: true, className: classes.title, classes: {
                    root: `headerbar-title ${(_a = props.title) === null || _a === void 0 ? void 0 : _a.toLowerCase()}-headerbar-title`,
                } }, props.title),
            props.isAuthenticated && renderUserMenu(),
            renderLogo())));
};
exports.default = HeaderBar;
//# sourceMappingURL=index.js.map